import Vue from 'vue'
// import App from './App'
// import router from './router'
// // import api from './api'
import axios from 'axios'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import store from './store'
// import 'iview/dist/styles/iview.css'
// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
// import '@/assets/style/base.css'
// import echarts from 'echarts'
// import ECharts from 'vue-echarts'
// import VueParticles from 'vue-particles'
// Vue.use(VueParticles)

// import infiniteScroll from 'vue-infinite-scroll'
// Vue.use(infiniteScroll)

// import { Anchor, AnchorLink, Affix } from 'iview'
// Vue.component('Anchor', Anchor)
// Vue.component('AnchorLink', AnchorLink)
// Vue.component('Affix', Affix)
// Vue.component('chart', ECharts)
// Vue.config.productionTip = false

// // 引入mock.js
// // require('./mock.js')

// Vue.use(ElementUI, {
//   size: 'small'
// })
// Vue.use(Viewer)
Vue.prototype.$axios = axios
// // Vue.prototype.$api = api
// Viewer.setDefaults({
//   Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
// })

// import { formatDate } from '@/api/utils'
// Vue.filter("formatDate", formatDate)

// /* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   store,
//   components: { App },
//   template: '<App/>'
// })

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import Carousel3d from 'vue-carousel-3d';
// import './utils/rem.js'
Vue.use(VideoPlayer)
Vue.use(Carousel3d);
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// Vue.use(VideoPlayer)

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});




// WEBPACK FOOTER //
// ./src/main.js